import { useQueryClient } from '@tanstack/react-query';

import {
  getGetAnalysisListQueryKey,
  getGetAnalysisQueryKey,
  useManualRetryScan,
} from '../../api/generated/insights';

const useManualRetryScanWithInvalidation = (brandId: string, analysisId: string) => {
  const queryClient = useQueryClient();

  return useManualRetryScan({
    mutation: {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: getGetAnalysisQueryKey(brandId, analysisId),
          }),
          queryClient.invalidateQueries({
            queryKey: getGetAnalysisListQueryKey(brandId),
          }),
        ]);
      },
    },
  });
};

export default useManualRetryScanWithInvalidation;
